$('.video-masonry').each(function() {
  const $section = $(this);

  $section.find('.video-masonry__contents').slick({
    slidesToShow: 4,
    autoplay: false,
    arrows: true,
    infinite: false,
    prevArrow: $section.find('.video-masonry__btn-prev'),
    nextArrow: $section.find('.video-masonry__btn-next'),
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const videoItems = document.querySelectorAll('.video-masonry__item-inner');

  videoItems.forEach((item) => {
    const video = item.querySelector('.custom-video');
    const volumeButton = item.querySelector('.video-display__volume-button');

    const volumeOffIcon = volumeButton.querySelector('.volume-off');
    const volumeOnIcon = volumeButton.querySelector('.volume-on');

    item.addEventListener('mouseenter', () => {
      item.classList.add('is-hovered');

      video.play().catch(() => {});
    });

    item.addEventListener('mouseleave', () => {
      item.classList.remove('is-hovered');

      video.pause();
      video.currentTime = 0;
      video.load();
    });

    volumeButton.addEventListener('click', (e) => {
      e.stopPropagation();

      video.muted = !video.muted;
      volumeButton.classList.toggle('is-unmuted', !video.muted);
    });
  });
});